import axios from "axios";
import app from "@/store/app";
import liff from "@line/liff";

const config = window.rs_line;

export default class Authentication {
  get isAuthenticated(): boolean {
    return this.tokens.authenticated;
  }

  get tokens(): LoginSuccess {
    const storage = localStorage.getItem("authentication");
    if (storage === null) {
      return {
        authenticated: false,
        access_token: "",
        id_token: "",
        language: "en_US"
      };
    }
    return JSON.parse(storage);
  }

  get openID(): string {
    const openID = localStorage.getItem("openID");
    return openID;
  }

  public async authorize(email: string, password: string) {
    if (this.openID) {
      const response = await axios({
        baseURL: config.base_url,
        url: `/login`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: { email, password, openID: this.openID }
      });

      const authData = response.data as LoginSuccess;
      this.setAuthentication(authData);
      return authData;
    } else return;
  }

  public async initLiff() {
    try {
      app.SET_IS_LOADING(true);
      await liff.init({ liffId: config.liff_id });
      if (liff.isInClient()) {
        const context = liff.getContext();
        if (context && context.userId) this.setOpenID(context.userId);
        else throw new Error();
      } else throw new Error();
    } catch (error) {
      window.alert("Error! Please open this in LINE");
    } finally {
      app.SET_IS_LOADING(false);
    }
  }

  public setOpenID(userId: string) {
    localStorage.setItem("openID", userId);
  }

  private setAuthentication(data: LoginSuccess) {
    localStorage.setItem("authentication", JSON.stringify(data));
  }

  public async logout() {
    const data = { type: "logout", openID: this.openID };

    await axios({
      url: `${config.base_url}/login`,
      method: "POST",
      headers: { authorization: this.tokens.access_token },
      data
    });

    await localStorage.removeItem("authentication");
  }

  public async checkLoggedIn() {
    try {
      app.SET_IS_LOADING(true);
      const checkAuthResponse = await axios({
        url: `${config.base_url}/login`,
        method: "POST",
        data: {
          openID: this.openID,
          type: "check-login"
        },
        headers: {
          authorization: this.tokens.access_token
        }
      });
      const { isLoggedIn } = checkAuthResponse.data;
      app.SET_IS_LOADING(false);
      return isLoggedIn;
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
